import Webcam from "react-webcam";
import React, { useContext } from "react";
import constants from "../../../constants";
import AlertContext from "../../../context/AlertContext";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import InstructionHooks from "../../../Hooks/InstructionPage/InstructionHooks";
import InstructionPageHooks from "../../../Hooks/InstructionPage/InstructionPageHooks";

export default function InstructionPageBody() {
  const Alert = useContext(AlertContext);

  const InstructionHks = InstructionHooks();
  const InstructionPageHks = InstructionPageHooks();
  const { handleWebCamError ,picRef} = useCommonFunctionHooks();
  const isPreview = new URLSearchParams(window.location.search).get("mode") === "preview";

  return (
    <div className="instructionPageBodyMainContainer">
      <ul className="instructionPageBodyUl">
        {(Alert.testData.libtype === constants.libTypeIds.ASSIGNMENT ||
          Alert.testData.proctored !== constants.PROCTORING_MODE.NONE) &&
        Alert.testData.testtype !== constants.libTypeIds.CODING_CHALLENGE &&
        Alert.testData.testtype !== constants.libTypeIds.SQL ? (
          <>
            <li>
              Ensure you are alone in the room and do not use any mobile device
              while taking this test.
            </li>
            <li>
              Please concentrate on the screen, your eye moments/face moments
              are being captured and this will effect your overall confidence
              score. A low confidence score will indicate plagiarism and system
              will flag your test.
            </li>
            <li>
              Ensure you do not switch tabs or use multiple screens during the
              test. Any attempt to switch tabs will be detected, and repeated
              tab switches will result in your test being automatically
              submitted.
            </li>
            {(Alert.testData.ainterview || Alert.testData.videoqn) && (
              <>
                <li>
                  The countdown timer in the top right corner shows the
                  remaining time for the complete test.
                </li>
                <li>
                  When the timer reaches zero, the test will automatically end
                  and be submitted.
                </li>
              </>
            )}
            {Alert.testData.ainterview ? (
              <>
                <li>
                  Respond thoughtfully to each question presented on the screen.
                  <b> Do not read the question loud.</b>
                </li>
                <li>
                  To move to the next question, choose the 'Next' button. You
                  can take a few seconds between each question, but be aware of
                  the overall timer. Once you click 'Next' the question will be
                  displayed and the recording starts.
                </li>
                <li>
                  Once you've answered the final question, select the 'Finish'
                  button to complete the interview.
                </li>
                <li>
                  Against each question, there is a time limit as shown on the
                  chat pop-up.
                </li>
              </>
            ) : Alert.testData.videoqn ? (
              <>
                <li>
                  Once you've reviewed the question, click the 'Next' button to
                  proceed. Recording begins as soon as the question is
                  displayed.
                </li>
                <li>
                  Each question has a time limit, which will be displayed
                  alongside the question on the screen. Ensure your response is
                  within this time frame.
                </li>
                <li>
                  After answering the final question, click the 'Submit' button
                  to complete the video assessment.
                </li>
              </>
            ) : Alert.testData.single ? (
              <>
                <li>
                  Competitive Coding helps you practice a specific topic of
                  coding to ensure you master it. So, you can attempt this
                  specific topic multiple times until you feel confident.
                </li>
                <li>
                  You need to pass the all test cases given to receive a full
                  score. The evaluation will be against hidden test cases and
                  not the once displayed or you to test.
                </li>
                <li>
                  Make sure your code is robust enough to handle edge cases and
                  unexpected inputs.
                </li>
              </>
            ) : (
              <>
                <li>
                  You can revisit the question at any time by using the "View
                  Question" button for reference.
                </li>
                <li>Do not copy or paste code from external sources.</li>
                <li>
                  We provide external links to Tutorials point, Java T point and
                  W3 Schools. You can refer these websites by clicking on the
                  icon on the right.
                </li>
                <li>
                  Your progress is automatically saved, so you can focus on the
                  task without worrying about losing your work.
                </li>
              </>
            )}
          </>
        ) : Alert.testData.testtype === constants.libTypeIds.CODING_CHALLENGE ||
          (Alert.testData.testtype === constants.libTypeIds.SQL &&
            Alert.testData.proctored !== constants.PROCTORING_MODE.NONE) ? (
          <div className="instructionPageBodyUlForCC">
            <li>
              The {InstructionHks.getTestType(Alert.testData)} is proctored, an
              invigilator will be monitoring your activity throughout the test.
            </li>
            <li>
              The countdown timer in the top right displays the remaining time
              available.
            </li>
            <li>
              When the countdown timer reaches zero, the test will be
              auto-submitted.
            </li>

            <li>
              If you switch tabs from this window, the assignment will be auto
              submitted. Every time you do this, your marks against this
              challenge will be reduced.
            </li>
            <li>
              The next time you engage in this challenge, you will be presented
              with a problem of similar level of difficulty to solve. You will
              not encounter the same problem again as it will be a fresh
              opportunity to test your skills.
            </li>
            <li>
              If you exhaust the challenges under this category of similar
              difficulty, your account will be locked and your score against
              this will be marked as "0".
            </li>
            <li>
              If you continue navigating away from this page multiple times,
              your account will be locked.
            </li>
          </div>
        ) : (
          <>
            <li>
              Each question will appear one at a time on the screen. Read
              carefully and answer thoughtfully to maximize your practice.
            </li>
            <li>
              Once you answered, it will be validated to determine whether it is
              correct or incorrect.
            </li>
            <li>Use the 'Next' button to move to the next question.</li>
            {Alert.testData.testtype !== constants.libTypeIds.SQL && (
              <li>
                If you pass the minimum criteria for this Assessment, you can
                move to the next section of the Learning Path, otherwise you
                need to retake this assessment until you meet the minimum
                criteria.
              </li>
            )}
          </>
        )}
      </ul>
      {(Alert.testData.videoqn ||
        (Alert.testData.testmode === constants.MODE.TEST_MODE &&
          (Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM || 
           Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC))) && (
            isPreview ? (
            <div className="instructionWebCam disabled-camera">
                <svg xmlns="http://www.w3.org/2000/svg" width="172" height="108" viewBox="0 0 172 108" fill="none">
                  <rect width="171.22" height="108" rx="10.5366" fill="#EAECF0"/>
                  <g clip-path="url(#clip0_3726_2607)">
                  <path d="M100.097 63.2194C100.097 63.918 99.8192 64.588 99.3252 65.082C98.8312 65.576 98.1612 65.8536 97.4626 65.8536H73.7552C73.0566 65.8536 72.3866 65.576 71.8926 65.082C71.3986 64.588 71.1211 63.918 71.1211 63.2194V48.7316C71.1211 48.033 71.3986 47.363 71.8926 46.869C72.3866 46.375 73.0566 46.0975 73.7552 46.0975H79.0235L81.6577 42.1462H89.5601L92.1943 46.0975H97.4626C98.1612 46.0975 98.8312 46.375 99.3252 46.869C99.8192 47.363 100.097 48.033 100.097 48.7316V63.2194Z" stroke="#667085" stroke-width="2.63415" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M85.6089 60.5853C88.5185 60.5853 90.8772 58.2266 90.8772 55.317C90.8772 52.4074 88.5185 50.0487 85.6089 50.0487C82.6993 50.0487 80.3406 52.4074 80.3406 55.317C80.3406 58.2266 82.6993 60.5853 85.6089 60.5853Z" stroke="#667085" stroke-width="2.63415" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_3726_2607">
                  <rect width="31.6098" height="31.6098" fill="white" transform="translate(69.8047 38.1951)"/>
                  </clipPath>
                  </defs>
                </svg>
            </div>
          )
        :
        (<Webcam
          screenshotFormat="image/jpeg"
          className="instructionWebCam"
          ref={picRef}
          onUserMediaError={handleWebCamError}
          videoConstraints={InstructionPageHks.videoConstraints}
        />)
      )}
    </div>
  );
}
